import { Video, Stethoscope, HeartHandshake, BookOpen, Package } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TrueWellnessSupportProps {
  onOpenModal?: () => void;
}

const TrueWellnessSupport = ({ onOpenModal }: TrueWellnessSupportProps) => {
  const supportFeatures = [
    { icon: Video, label: "Telehealth access" },
    { icon: Stethoscope, label: "Medical oversight" },
    { icon: HeartHandshake, label: "Ongoing patient support" },
    { icon: BookOpen, label: "Education resources" },
    { icon: Package, label: "Secure home delivery" },
  ];

  return (
    <section id="support" className="py-24 md:py-32 bg-[#181818] scroll-mt-20 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8">
        <div className="max-w-4xl mx-auto text-center space-y-12">
          {/* Header */}
          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white">
              Support at Every Step
            </h2>
            <p className="text-lg md:text-xl text-white/70 max-w-2xl mx-auto">
              Real providers. Real support. Personalized care designed around you.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-8">
            {supportFeatures.map((feature, index) => (
              <div 
                key={index}
                className="flex flex-col items-center gap-3 p-6 bg-white/5 rounded-2xl border border-white/10"
              >
                <div className="w-12 h-12 rounded-full bg-[#ffdb4d]/20 flex items-center justify-center">
                  <feature.icon className="w-6 h-6 text-[#ffdb4d]" />
                </div>
                <span className="text-sm font-medium text-white text-center">
                  {feature.label}
                </span>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <Button 
            size="lg" 
            className="font-semibold bg-[#ffdb4d] hover:bg-[#ffdb4d]/90 text-black px-8"
            onClick={onOpenModal}
          >
            See if You Qualify
          </Button>
        </div>
      </div>
    </section>
  );
};

export default TrueWellnessSupport;
